<template>
  <div style="width: 100%">
    <v-row class="justify-center ma-2">
      <v-spacer />
      <v-col
        cols="6"
        md="4"
      >
        <v-autocomplete
          v-model="unidade"
          :item-text="getUnidadeSiglaAndNome"
          :items="unidades"
          label="Selecione a unidade"
          placeholder="Digite para pesquisar..."
          return-object
        />
      </v-col>
    </v-row>
    <v-row class="justify-center ma-2">
      <keep-alive>
        <component
          :is="currentComponent"
          :key="unidade.id"
          :mapeamento="mapeamento"
        />
      </keep-alive>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MonitoramentoUnidadesOrganograma
from '@/components/monitoramento/mapeamento/MonitoramentoUnidadesMapeamentoOrganograma';

export default {
  name: 'MonitoramentoUnidadesMapeamento',

  components: { MonitoramentoUnidadesOrganograma },

  props: {
    mapeamento: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      currentComponent: 'MonitoramentoUnidadesOrganograma',
    };
  },

  computed: {
    ...mapState({
      unidades: (state) => state.monitoramento.mapeamento.unidades,
    }),
    unidade: {
      get() {
        return this.$store.state.monitoramento.mapeamento.unidade;
      },
      set(value) {
        this.$store.dispatch('monitoramento/setUnidadeMapeamento', value);
      },
    },
  },

  methods: {
    getUnidadeSiglaAndNome(item) {
      return `${item.sigla} - ${item.nome}`;
    },
  },
};
</script>
